import $ from 'jquery';
import { initialize } from 'linksoft';

export default function () {
    $('body').off('click', '[data-toggle="modal"]');
    $('body').on('click', '[data-toggle="modal"]', function () {
        var href = $(this).attr("href");
        var target = $(this).data("target");
        if (href && href !== 'javascript:void(0)' && href !== '#') {
            $(target + ' .modal-content').load(href, function () {
                initialize.trigger($(target));
            });
        }
    });
}


// WEBPACK FOOTER //
// ./App/components/modules/remoteModal.js